var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6435 23.6465V0.702576H16.9486V8.36332H10.2837V17.786H3.58059V23.6082H0.516296V25.6H3.58059H10.2837H12.2755H16.9486H18.9404H25.6435H28.5163V23.6082H25.6435V23.6465ZM5.57238 23.6465V19.8161H10.2454V23.6465H5.57238ZM12.2755 23.6465V17.8243V10.3934H16.9486V23.6465H12.2755ZM18.9787 23.6465V8.40162V2.73267H23.6517V23.6848H18.9787V23.6465Z",
    fill: "#F5CA6C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.13f01082.svg";
export { ForwardRef as ReactComponent };